import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getPaletteColor } from 'pcln-design-system'
import TravelerSelection from '@pcln/traveler-selection'

const StyledTravelerSelection = styled(TravelerSelection)`
  > button {
    font-weight: normal;
    border-style: solid;
    border-width: 1px;
    border-color: ${getPaletteColor('border.base')};
  }
`

const ChangeSearchPassengers = ({
  passengers,
  setPassengers,
  isWhiteLabel,
  isReshopExperience,
  subLabelMap,
  lapInfantLabel,
  shouldCountLapInfant,
  maxChildren,
  showBackButton,
  isMobileView = false,
}) => (
  <StyledTravelerSelection
    height={46}
    initialValues={passengers}
    onChange={setPassengers}
    isWhiteLabel={isWhiteLabel}
    isTravelerSelectionDisabled={isReshopExperience}
    borderRadius='lg'
    subLabelMap={subLabelMap}
    lapInfantLabel={lapInfantLabel}
    shouldCountLapInfant={shouldCountLapInfant}
    maxChildren={maxChildren}
    showBackButton={showBackButton}
    trapFocus={false}
    usePopoverPortal={!isMobileView}
  />
)

ChangeSearchPassengers.propTypes = {
  passengers: PropTypes.object,
  setPassengers: PropTypes.func,
  isWhiteLabel: PropTypes.bool,
  isReshopExperience: PropTypes.bool,
  subLabelMap: PropTypes.shape({
    adults: PropTypes.string,
    children: PropTypes.string,
    lapInfants: PropTypes.string,
  }),
  lapInfantLabel: PropTypes.string,
  shouldCountLapInfant: PropTypes.bool,
  maxChildren: PropTypes.number,
  showBackButton: PropTypes.bool,
  isMobileView: PropTypes.bool,
}

export { ChangeSearchPassengers }
